var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevrondowm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5172 0.38113C13.8479 0.786505 13.8243 1.38375 13.4463 1.76215L7.60396 7.60414C7.40812 7.79998 7.14613 7.90599 6.87436 7.90599C6.6025 7.90599 6.34099 7.80016 6.14441 7.60414L0.302302 1.76203C-0.100767 1.35848 -0.100767 0.705272 0.302302 0.30278C0.705508 -0.100907 1.35889 -0.100907 1.76188 0.302661L6.87436 5.41473L11.9867 0.30278C12.3647 -0.0756553 12.9626 -0.0993273 13.368 0.231783L13.4464 0.302736L13.5172 0.38113Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondowm);
export default __webpack_public_path__ + "static/media/chevrondowm.0b94bfc9b7bfdc72886403d5234699e1.svg";
export { ForwardRef as ReactComponent };